import { AxiosPromise } from 'axios';

import { ApiService } from './api.service';
import { TerminationDataInterface } from 'app/shared/interfaces/TerminationData.interface';

export const TerminationGeneratorService = {
  sendTerminationData(data: TerminationDataInterface): AxiosPromise {
    return ApiService.post('document-generator/notice', data);
  },
};
